import styled from 'styled-components';
import { setAlpha } from '../../../styles/utils';
import { Box, Flex, VStack } from '../../Core';
import { mobileButtonBackgroundCSS } from '../styles';

export const TAB_BAR_HEIGHT = 62;

export const TAB_BUTTON_SIZE = 54;
export const SelectedIndicatorWrapper = styled(Box)`
  height: ${TAB_BUTTON_SIZE}px;
  border-radius: ${TAB_BUTTON_SIZE / 2}px;
  position: absolute;
  background: ${({ theme }) => setAlpha(0.8, theme.colors.gray['050'])};
  transition: transform 300ms;
  left: ${({ theme }) => theme.spacing4}px;
`;

export const TabBarWrapper = styled(Flex)`
  height: ${TAB_BAR_HEIGHT}px;
  padding: ${({ theme }) => theme.spacing4}px;
  align-items: center;
  justify-content: center;
  border-radius: ${TAB_BAR_HEIGHT / 2}px;
  ${mobileButtonBackgroundCSS};
`;

export const TabButtonWrapper = styled(VStack)<{ isSelected?: boolean }>`
  height: ${TAB_BUTTON_SIZE}px;
  border: none;
  position: relative;
  z-index: 1;
  flex: 1;
  gap: ${({ theme }) => theme.spacing4}px;
  border-radius: ${TAB_BUTTON_SIZE / 2}px;
  color: ${({ theme }) => theme.colorTextImportant};
  height: ${TAB_BUTTON_SIZE}px;
  padding-bottom: ${({ theme }) => theme.spacing4}px;
  padding-top: ${({ theme }) => theme.spacing2}px;
  transition: color 300ms;
`;

export const TabBarAccessoriesWrapper = styled(Box)`
  &:not(:empty) {
    margin-bottom: ${({ theme }) => theme.spacing8}px;
  }
`;
